export default __webpack_public_path__ + "static/koala-76dfcbbf1778b435caae149bbcaf42f3.png";